/**
 * Created by mrocha on 5/26/16.
 */

// FormsView.js

import RestService from 'RestService';
import eventBus         from 'EventBus.js';

import util from '../../service/util/Util.js';
import $ from 'jquery';
import {View} from 'backbone';
import constants        from 'Constants.js';

//======================================================================================
// Presents a clickable drill-down tree view. No HTML template used.
// -Lou Mauget, 2016-02-27
//======================================================================================

class FormsView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.checkForInstances= opts.checkForInstances!==undefined ? opts.checkForInstances : true;
        this.publishedInstances= opts.publishedInstances!==undefined ? opts.publishedInstances : false;
        // PF-1857 Adding extra condition for selecting a form with instances.
        this.selectableFormWithInstances= opts.selectableFormWithInstances!==undefined ? opts.selectableFormWithInstances : false;

        this.STATIC_TREEVIEW_OPTIONS = ['Private Apps', 'Shared Apps'];
        this.tree = [
            {
                text: "Private Apps",
                icon: constants.DB_ICON_FOLDER,
                borderColor: constants.DB_BORDER_COLOR,
                color: constants.DB_FG_DIM,
                backColor: constants.DB_BACK_COLOR,
                selectable: true,
                state: {checked: false, disabled: false, expanded: false, selected: false},
                tags: ['attn'],
                nodes: [{}]  // Adding empty array subnodes so the UI can render them and new ones can be added.
            },

            {
                text: "Shared Apps",
                icon: constants.DB_ICON_FOLDER,
                borderColor: constants.DB_BORDER_COLOR,
                color: constants.DB_FG_DIM,
                backColor: constants.DB_BACK_COLOR,
                selectable: true,
                state: {checked: false, disabled: false, expanded: false, selected: false},
                tags: ['attn'],
                nodes: [{}]  // Adding empty array subnodes so the UI can render them and new ones can be added.
            }
        ];

        this.listenTo(this.model, 'change', this.render);

        return this;
    }
    //=================================================================
    // Adds Folders and Items to the in-memory model so they can be properly rendered into the
    // TreeView Widget.
    //=================================================================
    _addItemsAndFoldersToTreeModel(currentNode,forms,groupType,tag){
        currentNode.nodes=[];
        if(forms.Group) {

            // Checking whether is an Array or an object so we can loop the items
            // or access the single object properties
            if (forms.Group instanceof Array) {

                for (let group of forms.Group) {
                    currentNode.nodes.push(this.createNode(
                        {
                            text: group['@name'],
                            GUID: group['@guid'],
                            icon: constants.DB_ICON_FOLDER,
                            nodes: [],
                            groupType: groupType || currentNode.groupType,
                            groupId: group['@id']
                        }))
                }
            }
            else{
                currentNode.nodes.push(this.createNode(
                    {
                        text: forms.Group['@name'],
                        GUID: forms.Group['@guid'],
                        icon: constants.DB_ICON_FOLDER,
                        nodes: [],
                        groupType: groupType || currentNode.groupType,
                        groupId: forms.Group['@id']
                    }))
            }
        }

        if(forms.Item) {
            if (forms.Item instanceof Array) {
                for (let form of forms.Item) {
                    this.addItem(form,currentNode,groupType);
                }
            }
            else {
                this.addItem(forms.Item,currentNode,groupType);
            }
        }

        // This section is for open instances of nodes.
        if(forms.Instance && this.options.checkForInstances) {
            if (forms.Instance instanceof Array) {
                for (let instance of forms.Instance) {
                    const formattedDate=util.getFormattedDate(instance['@LastSubmissionDate']);
                    currentNode.nodes.push(this.createNode({text: instance['@Name']+' '+formattedDate,icon:constants.DB_ICON_LISTS,tags:[tag],
                        formInstanceId:instance['@Id']}));
                }
            }
            else {
                const formattedDate=util.getFormattedDate(forms.Instance['@LastSubmissionDate']);
                currentNode.nodes.push(this.createNode({text: forms.Instance['@Name']+' '+formattedDate,icon:constants.DB_ICON_LISTS,
                    tags:['openInstance'],formInstanceId:forms.Instance['@Id']}));
            }
        }
    }

    // Adding items on the model node.
    // Depending if it is from the Edit Forms Section or in the View Forms Section, a different process is performed.
    addItem(form,currentNode,groupType){

        // If a groupType was set, then add an extra property to state that the node is from the View Forms Section so it can be processed on the onNodeSelected event.
        if(groupType === constants.FORMS_PUBLISHED_GROUP_TYPE){
            if(form['@hasChildren'] === 'True' && this.options.checkForInstances) {
                currentNode.nodes.push(this.createNode({text: form['@name'],
                    viewFormsId: form['@id'],
                    GUID:form['@guid'],
                    linkId: form['@linkId'],
                    nodes:[{}],
                    tags:['viewableInstance']}));
            }
            else {
                currentNode.nodes.push(this.createNode({text: form['@name'],tags:['viewableInstance'],groupId: form['@id']}));
            }
        }
        // If a flag from EditForms is not Set, two static folders should be added without requesting something from the API.
        else {
            if (form['@hasChildren'] === 'True' && this.options.checkForInstances) {
                currentNode.nodes.push(this.createNode({
                    text: form['@name'],
                    editFormsId: form['@id'],
                    GUID:form['@guid'],
                    linkId: form['@linkId'],
                    nodes: [{
                        text: 'Open Instances',
                        groupId: form['@id'],
                        icon: constants.DB_ICON_FOLDER,
                        nodes: [{}]
                    },
                        {
                            text: 'Closed Instances',
                            groupId: form['@id'],
                            icon: constants.DB_ICON_FOLDER,
                            nodes: [{}]
                        }]
                }));
            }
            else {
                currentNode.nodes.push(this.createNode({text: form['@name'],groupId: form['@id'], id:form['@id'], GUID:form['@guid'], linkId:form['@linkId'] }));
            }
        }
    }
    // =====================================================================================================
    // Creates a node by passing custom properties that will be overwritten by the default ones if needed.
    // =====================================================================================================
    createNode(properties = {}) {
        let defaults = {
            text: '',
            icon: constants.DB_ICON_EMPTY,
            borderColor: constants.DB_BORDER_COLOR,
            color: constants.DB_FG_DIM,
            backColor: constants.DB_BACK_COLOR,
            selectable: true,
            tags: ['attn']
        };
        return Object.assign({}, defaults, properties);

    }

    // ========================================================================
    // Performs a deep search of the current node being clicked in the treeview model so it can be updated
    // and render a new one once again.
    // ========================================================================
    _getObjectByProperty(tree,value,property) {
        var result = null;
        if (tree instanceof Array) {
            for (var i = 0; i < tree.length; i++) {
                result = this._getObjectByProperty(tree[i],value,property);
                if (result) {
                    break;
                }
            }
        }
        else  if ( typeof tree !== 'function' ) {
            for (var prop in tree) {
                if (prop === property) {
                    if (tree[prop] === value) {
                        return tree;
                    }
                }
                if (tree[prop] instanceof Object || tree[prop] instanceof Array) {
                    result = this._getObjectByProperty(tree[prop],value,property);
                    if (result) {
                        break;
                    }
                }
            }
        }
        return result;
    }



    //=======================================================================
    // Dispatch correct model update on each node collapsed in the Tree View.
    //=======================================================================
    _onNodeCollapsed(evt, node) {
        if (this.STATIC_TREEVIEW_OPTIONS.indexOf(node.text) !== -1) {
            this._processCollapseForStaticNodes(node);
        } else {
            this._processCollapseForDynamicNodes(node);
        }
    }

    //=======================================================================
    // Dispatch correct model update on each node expanded in the Tree View.
    //=======================================================================
    _onNodeExpanded(evt, node) {
        if (this.STATIC_TREEVIEW_OPTIONS.indexOf(node.text) !== -1) {
            this._processExpansionForStaticNodes(node);
        } else {
            this._processExpansionForDynamicNodes(node);
        }
    }


    _checkIsFolder(node){
        return node.icon === constants.DB_ICON_FOLDER;
    }

    //==================================================================
    // Dispatch correct detail subview according to selected
    // tree node.
    //==================================================================
    _onFormSelected(evt, node) {
        console.log('Node Selected',node);
        console.log('Check for instances',this.options.checkForInstances);
        const formIcon = constants.DB_ICON_EMPTY;
        if(!this.options.checkForInstances && node.icon === formIcon){
            eventBus.trigger('FormSelected', node.id, node.text, node.GUID, node.linkId);
        }

        // PF-1857 Perfoming the validation for selecting a folder that has instances.
        else if(this.options.selectableFormWithInstances){
            eventBus.trigger('FormSelected', node.id, node.text, node.GUID, node.linkId);
        }
        else if (node.nodes) {
            $('button.btn-select-field').button("disable");
        }
        else {
            eventBus.trigger('FormSelected', node.id, node.text, node.GUID, node.linkId);
        }
    }

    // ==============================================================
    // Updates the status of the expansion of the node being clicked
    // if it is one that was retrieved from the API.
    // ==============================================================
    _processCollapseForDynamicNodes(node) {
        let modelNode;
        if (node.groupId){
            modelNode=this._getObjectByProperty(this.tree,node.groupId,'groupId');
        }
        else if(node.editFormsId){
            modelNode=this._getObjectByProperty(this.tree,node.editFormsId,'editFormsId');
        }
        else{
            modelNode=this._getObjectByProperty(this.tree,node.viewFormsId,'viewFormsId');
        }
        modelNode.state = {expanded : false};
    }

    // ==============================================================
    // Updates the status of the expansion of the node being clicked
    // if it is one that is between the four expected groups(Edit,View,Private).
    // ==============================================================
    _processCollapseForStaticNodes(node) {
        switch (node.text) {
            case 'Edit Forms':
                this.tree[0].state.expanded = false;
                break;
            case 'View Forms':
                this.tree[1].state.expanded = false;
                break;
            case 'Private Forms':
                this.tree[0].nodes[0].state = {expanded: false};
                break;
        }
    }

    // ======================================================================================================
    // Retrieves the child nodes of an specific group if the group was clicked, and also updates the current
    // model so the treeview can render these retrieved child nodes as well.
    // ======================================================================================================
    _processExpansionForDynamicNodes(node) {
        // Not making the API call as it is an static node, but make it expanded in the tree model object literal.
        let modelNode = this._getObjectByProperty(this.tree, node.groupId,'groupId');
        RestService.getFormsByGroupType(modelNode.groupType, modelNode.groupId).then((data) => {
            let forms = data.RESULT.RESPONSE.Group;
            this._addItemsAndFoldersToTreeModel(modelNode, forms,null,'openInstanceDetail');

            // Modifying the state to be expanded now both on the parent and children.
            modelNode.state = {expanded: true};
            this.render();

        }).catch((error) => {
            console.log(error);
        });

    }

    // ======================================================================================================
    // Method that calls an specific functionality for each one of the expected groups at start.
    // ======================================================================================================
    _processExpansionForStaticNodes(node) {
        switch (node.text) {
            case 'Private Apps':
                this._processPrivateForms();
                break;
            case 'Shared Apps':
                this._processSharedForms();
                break;
        }
    }

    _processPrivateForms() {
        let self = this;
        if ( !this.options.publishedInstances ) {
            RestService.getFormsByGroupType(constants.FORMS_PRIVATE_GROUP_TYPE).then((data) => {
                let privateForms = data.RESULT.RESPONSE.Group;
                this._addItemsAndFoldersToTreeModel(self.tree[0], privateForms,constants.FORMS_PRIVATE_GROUP_TYPE);

                // Modifying the state to be expanded now both on the parent and children.
                self.tree[0].state.expanded = true;
                this.render();

            }).catch((error) => {
                console.log(error);
            });
        } else {
            RestService.getBrowseFormsForReporting(constants.FORMS_PRIVATE_GROUP_TYPE).then((data) => {
                let privateForms = data.RESULT.RESPONSE.Group;
                this._addItemsAndFoldersToTreeModel(self.tree[0], privateForms,constants.FORMS_PRIVATE_GROUP_TYPE);
                // Modifying the state to be expanded now both on the parent and children.
                self.tree[0].state.expanded = true;
                this.render();

            }).catch((error) => {
                console.log(error);
            });
        }
    }

    _processSharedForms() {
        let self = this;
        if ( !this.options.publishedInstances ) {
            RestService.getFormsByGroupType(constants.FORMS_SHARED_GROUP_TYPE).then((data) => {
                let sharedForms = data.RESULT.RESPONSE.Group;
                this._addItemsAndFoldersToTreeModel(self.tree[1], sharedForms,constants.FORMS_SHARED_GROUP_TYPE);
                // Modifying the state to be expanded now both on the parent and children.
                self.tree[1].state.expanded = true;
                this.render();

            }).catch((error) => {
                console.log(error);
            });
        } else {
            RestService.getBrowseFormsForReporting(constants.FORMS_SHARED_GROUP_TYPE).then((data) => {
                let sharedForms = data.RESULT.RESPONSE.Group;
                this._addItemsAndFoldersToTreeModel(self.tree[1], sharedForms,constants.FORMS_SHARED_GROUP_TYPE);
                // Modifying the state to be expanded now both on the parent and children.
                self.tree[1].state.expanded = true;
                this.render();
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    //==================================================================
    // Deafen this entire view. The goals are (1) to not respond to
    // events for our $el when an nother view is using it; (2)
    // prevent memory leaks by leaving listeners by the side of the
    // road.
    //==================================================================
    remove() {
        let self = this;
        this.undelegateEvents();
        if ($(self.options.el).treeview()) {
            $(self.options.el).treeview('remove');
        }

        super.remove();
    }




    //==================================================================
    // Normal BB rendering from HTML template, plus start select
    // listener for tree.
    //==================================================================
    render() {
        let self = this;
        // Rendering the tree.
        $(self.options.el).treeview(
            {
                data: self.tree, levels: 2, onNodeSelected: self._onFormSelected.bind(this),
                // Binding the current scope to the Backbone model so the function assigned can see it and manipulate the render process.
                onNodeExpanded: self._onNodeExpanded.bind(this),
                onNodeCollapsed: self._onNodeCollapsed.bind(this)
            }
        );

        //$(this.$el[0]).treeview( 'selectNode', [ tree[0], { silent: false } ] );

        this.delegateEvents();
        

        return this;
    }

}

export default FormsView;
